import type { SVGProps } from 'react';

export const NdulgeLogoIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg width="56" height="11" viewBox="0 0 56.0002 11.2008" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g>
            <path
                d="M8.49122 11.0655H6.86943L1.74815 3.20177H1.71776V11.0655H0V0H1.62179L6.74148 7.86372H6.77346V0H8.49122V11.0655Z"
                fill="currentColor"
            />
            <g>
                <path
                    d="M11.2307 11.1041V0.143311H14.6439C17.1309 0.143311 18.7063 1.42996 18.7063 4.97254V6.27482C18.7063 9.8174 17.1293 11.1041 14.6439 11.1041H11.2307V11.1041ZM17.7643 6.27482V4.97254C17.7643 1.97088 16.5775 1.0016 14.6439 1.0016H12.1744V10.2473H14.6439C16.5615 10.2473 17.7643 9.32651 17.7643 6.27639V6.27482Z"
                    fill="currentColor"
                />
                <path
                    d="M21.0634 6.62501V0.143311H22.0054V6.62501C22.0054 9.16704 23.0786 10.3427 25.0443 10.3427C27.01 10.3427 28.0832 9.16704 28.0832 6.62501V0.143311H29.0252V6.62501C29.0252 9.85023 27.4818 11.1994 25.0443 11.1994C22.6068 11.1994 21.0634 9.84867 21.0634 6.62501V6.62501Z"
                    fill="currentColor"
                />
                <path
                    d="M32.8917 10.2458H38.5472V11.1041H31.9496V0.143311H32.8917V10.2458V10.2458Z"
                    fill="currentColor"
                />
                <path
                    d="M47.0454 5.7509V6.19646C47.0454 9.69058 45.502 11.2008 42.9989 11.2008C40.4959 11.2008 39.018 9.81877 39.018 6.27619V4.97391C39.018 1.43133 40.5614 0.0493165 42.9989 0.0493165C44.9822 0.0493165 46.5912 1.0655 46.9478 3.46527H46.0218C45.6635 1.63926 44.5599 0.907603 42.9989 0.907603C41.0972 0.907603 39.9601 1.98789 39.9601 4.97391V6.27619C39.9601 9.26222 41.0972 10.3425 42.9989 10.3425C44.9006 10.3425 45.9898 9.29348 46.0874 6.60919H43.0485V5.7509H47.047H47.0454Z"
                    fill="currentColor"
                />
                <path
                    d="M56.0002 0.143311V1.0016H50.3447V5.00537H55.5124V5.86366H50.3447V10.2473H56.0002V11.1056H49.4027V0.143311H56.0002Z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
);
